<template>
    <section class="mine-account">
        <wealth />
    </section>
</template>

<script>
	/** eslint-disable */
	import Wealth from './Wealth.vue'

	export default {
		name: 'MineAccount',
		components: {
			Wealth
		}
	}
</script>

<style lang="scss" scoped>
    @import '../style/main';

    .mine-account {
        overflow-y: scroll;
        padding: rem(40) 0;
        height: 100%;
        background-color: #f3f4f6;
    }
</style>
